export { IconlyLightOutlineArrowDown21 } from "./IconlyLightOutlineArrowDown21";
